import {
    receiveNumber,
    receiveString,
} from "../../../../controllers/adapters/receives"

const MaestrosAdapters = {

    // GET /integra-web/categorias-publicas
    // Catálogos de empresas. El backend ya devuelve el texto en el idioma de la
    // petición (tabla `integra_categoria_textos`), por eso no se pide nada más.
    // Respuesta: { status, message, code, data: [{ id, nombre, icono_path }] }
    GET_CATEGORIAS_PUBLICAS: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    id: receiveNumber(item.id),
                    nombre: receiveString(item.nombre),
                    icono_path: receiveString(item.icono_path),
                }
            },

            adapter: function (data: any) {

                const elementos = Array.isArray(data?.data?.data) ? data.data.data : []

                return {
                    items: elementos.map((item: any) => this.schema(item))
                }
            }
        },
    },

    // GET /integra-web/departamentos-publicas
    // Igual que las categorías pero sobre `integra_departamentos`
    // (`data: [{ id, nombre }]`).
    GET_DEPARTAMENTOS_PUBLICAS: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    id: receiveNumber(item.id),
                    nombre: receiveString(item.nombre),
                }
            },

            adapter: function (data: any) {

                const elementos = Array.isArray(data?.data?.data) ? data.data.data : []

                return {
                    items: elementos.map((item: any) => this.schema(item))
                }
            }
        },
    },
}

export {
    MaestrosAdapters,
}